function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialInputAdornment from "../../../../__snowpack__/pkg/@mui/material/InputAdornment.js";
import {Field} from "../../../../__snowpack__/pkg/formik.js";
import React, {useCallback, useMemo} from "react";
import {getRandomString} from "../../../common/generic-react.functions.js";
import Icon from "../icon/icon.component.js";
import {InputContainer} from "./input.styles.js";
function Input({
  value: initialValue,
  children,
  dataCy,
  translate,
  label,
  name,
  id,
  placeholder,
  size,
  fullWidth,
  type = "text",
  disabled,
  readOnly,
  color,
  variant = "outlined",
  helperText,
  error,
  required,
  multiline,
  rows,
  maxRows,
  startIcon,
  endIcon,
  onStartIconClick,
  onEndIconClick,
  onChange,
  inputProps,
  onKeyPress,
  onKeyDown,
  ...otherProps
}) {
  const {
    t
  } = useTranslation();
  const itemName = useMemo(() => name || getRandomString(), [name]);
  const itemId = useMemo(() => id || `${name || "unnamed"}__${getRandomString()}`, [id, name]);
  const _dataCy = useMemo(() => dataCy || translate || children, [children, dataCy, translate]);
  const text = useMemo(() => translate ? t(translate) : label || children || void 0, [children, label, t, translate]);
  const itemPlaceholder = useMemo(() => placeholder || typeof text === "string" ? text : void 0, [placeholder, text]);
  const handleChange = useCallback((event, field) => {
    if (!disabled) {
      field?.onChange(event);
      if (onChange) {
        onChange(event);
      }
    }
  }, [disabled, onChange]);
  const startAdornment = useMemo(() => startIcon && /* @__PURE__ */ React.createElement(MaterialInputAdornment, {
    position: "start"
  }, /* @__PURE__ */ React.createElement(Icon, {
    size: "medium",
    onClick: onStartIconClick
  }, startIcon)), [onStartIconClick, startIcon]);
  const endAdornment = useMemo(() => endIcon && /* @__PURE__ */ React.createElement(MaterialInputAdornment, {
    position: "end"
  }, /* @__PURE__ */ React.createElement(Icon, {
    size: "medium",
    onClick: onEndIconClick
  }, endIcon)), [endIcon, onEndIconClick]);
  const InputComponent = useCallback(({
    field,
    form,
    meta = form?.getFieldMeta(field.name)
  }) => /* @__PURE__ */ React.createElement(InputContainer, _extends({}, otherProps, {
    style: {
      height: 36
    },
    "data-cy": _dataCy,
    inputProps,
    value: field?.value || initialValue || "",
    type,
    label: text,
    name: itemName,
    placeholder: itemPlaceholder,
    id: itemId,
    size,
    fullWidth,
    variant,
    disabled,
    InputProps: {
      readOnly,
      startAdornment,
      endAdornment
    },
    color,
    required,
    error: error || meta?.touched && !!meta?.error,
    helperText: meta?.touched && meta?.error || helperText,
    multiline,
    rows,
    maxRows,
    onKeyDown,
    onKeyPress,
    onChange: (e) => handleChange(e, field)
  })), [otherProps, _dataCy, inputProps, initialValue, type, text, itemName, itemPlaceholder, itemId, size, fullWidth, variant, disabled, readOnly, startAdornment, endAdornment, color, required, error, helperText, multiline, rows, maxRows, onKeyDown, onKeyPress, handleChange]);
  return /* @__PURE__ */ React.createElement(Field, {
    name: itemName,
    component: InputComponent
  });
}
export default /* @__PURE__ */ React.memo(Input);
